import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSummernoteModule } from 'ngx-summernote';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DxDataGridModule } from 'devextreme-angular';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { PanelsModule } from '../../../shared/panels/panels.module';
import { DialogsModule } from '../../../shared/dialogs/dialogs.module';
import { DialogsService } from '../../../shared/dialogs/dialogs.service';
import { Select2Module } from '../../../shared/ui/forms/inputs/oops-select2/select2.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DaterangepickerModule } from '../../../shared/ui/forms/inputs/oops-daterangepicker/daterangepicker.module';
import { UtilsModule } from '../../../shared/utils/utils.module';
import { Helper } from '../../../shared/helper/app.helper';

import { TextComponent } from './text.component';
import { TextTableComponent } from './text-table/text-table.component';
import { TextDetailComponent } from './text-detail/text-detail.component';
import { TextDetailDirective } from './text-detail/text-detail.directive';
import { TextLibraryTableComponent } from './text-library-table/text-library-table.component';
import { TextLibraryTableDirective } from './text-library-table/text-library-table.directive';
import { MatIconModule } from '@angular/material/icon';
import { FocusingModule } from 'src/app/shared/ui/forms/inputs/focusing.module';

@NgModule({
    declarations: [
        TextComponent,
        TextTableComponent,
        TextDetailComponent,
        TextDetailDirective,
        TextLibraryTableComponent,
        TextLibraryTableDirective
    ],
    exports: [
        TextComponent, TextTableComponent, TextDetailComponent, TextDetailDirective,
        TextLibraryTableComponent, TextLibraryTableDirective
    ],
    imports: [
        BsDropdownModule,
        ButtonsModule,
        CollapseModule,
        CommonModule,
        DaterangepickerModule,
        DialogsModule,
        DxDataGridModule,
        FocusingModule,
        FormsModule,
        MatIconModule,
        NgbModule,
        NgxSummernoteModule,
        PanelsModule,
        ReactiveFormsModule,
        Select2Module,
        SweetAlert2Module,
        TooltipModule,
        UtilsModule
    ],
    providers: [
        DialogsService, Helper
    ]
})
export class TextModule {
}